import clsx from 'clsx'

import { ImageOptimized } from 'shared/ui/image-optimized'

import s from './styles.module.scss'

interface IntroItemProps {
  index: number
  title: string
  description: string
  img: string
}

export const IntroItem = ({
  index,
  title,
  description,
  img,
}: IntroItemProps) => (
  <div className={s.flex}>
    <div>
      <p className={clsx(s.label, 'semi-bold-14')}>
        {index + 1}. {title}
      </p>
      <p className={clsx(s.description, 'medium-14')}>{description}</p>
    </div>

    <ImageOptimized
      src={img}
      className={s.image}
      width={50}
      height={50}
      objectFit="contain"
    />
  </div>
)
